export function Section2Tagline() {
  return (
    <div className="copy-block narrow" data-motion="reveal">
      <h2>Markets are loud. Signal is rare.</h2>
      <p>
        VERUS distills price, fundamentals, yields, insider activity, and news into a
        single cross-sectional read. No daily emails. No glossy charts. One terminal,
        one operator, one source of truth.
      </p>
    </div>
  )
}
